import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Bible from '../pages/bible/page';
import Characters from '../pages/characters/page';
import Radio from '../pages/radio/page';
import Kids from '../pages/kids/page';
import Devotionals from '../pages/devotionals/page';
import Studies from '../pages/studies/page';
import PrayerRequests from '../pages/prayer-requests/page';
import Gallery from '../pages/gallery/page';
import Location from '../pages/location/page';
import Filiais from '../pages/filiais/page';
import Coimep from '../pages/coimep/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/bible',
    element: <Bible />,
  },
  {
    path: '/characters',
    element: <Characters />,
  },
  {
    path: '/radio',
    element: <Radio />,
  },
  {
    path: '/kids',
    element: <Kids />,
  },
  {
    path: '/devotionals',
    element: <Devotionals />,
  },
  {
    path: '/studies',
    element: <Studies />,
  },
  {
    path: '/prayer-requests',
    element: <PrayerRequests />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/location',
    element: <Location />,
  },
  {
    path: '/filiais',
    element: <Filiais />,
  },
  {
    path: '/coimep',
    element: <Coimep />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;